import axios from "axios"

const state = {
    result:[],
    type:'',
    value:'',
    selected:{
        pefc:{},
        sofc:{},
        hw_senyo:{},
        hw_ittai:{},
        electricHeatPump:{},
    },
}

const getters = {
    /**
     * 検索結果を取得
     */
    getResult(state){
        return state.result
    },
    /**
     * 検索対象が何であるかを取得
     */
    getType(state){
        return state.type
    },
    /**
     * 検索テキストが何であるかを取得
     */
    getValue(state){
        return state.value
    },
    /**
     * 選択されたPEFCの情報を取得
     */
    getSelectedPefc(state){
        return state.selected.pefc
    },
    /**
     * 選択されたSOFCの情報を取得
     */
    getSelectedSofc(state){
        return state.selected.sofc
    },
    /**
     * 選択された給湯専用型:電気ヒートポンプ・ガス瞬間式併用型給湯機の情報を取得
     */
    getSelectedHWSenyo(state){
        return state.selected.hw_senyo
    },
    /**
     * 選択された給湯・温水暖房一体型:電気ヒートポンプ・ガス瞬間式併用型給湯機の情報を取得
     */
    getSelectedHWIttai(state){
        return state.selected.hw_ittai
    },
    /**
     * 選択された電気ヒートポンプの情報を取得
     */
    getSelectedElectricHeatPump(state){
        return state.selected.electricHeatPump
    }
}

const actions = {
    /**
     * 検索結果をstateに保存
     */
    setResult({commit}, {value, result, type}) {
        commit('setResult', {value, result, type})
    },
    /**
     * 選択された機器をstateに保存
     */
    setSelected({commit}, {value, type}) {
        commit('setSelected', {value, type})
    },
    /**
     * コジェネ機器の検索を実行
     */
    //eslint-disable-next-line no-unused-vars
    searchCogen({state}, {type, filter}) {
        return axios.get('/api/search/cogen', {params:{type, filter}})
    },
    /**
     * 給湯機器の検索を実行
     */
    //eslint-disable-next-line no-unused-vars
    searchHybridWaterHeater({state}, {filter}) {
        return axios.get('/api/search/hybridwaterheater', {params:{filter}})
    },
    /**
     * 給湯機器の検索を実行
     */
    //eslint-disable-next-line no-unused-vars
    searchElectricHeatPump({state}, {filter}) {
        return axios.get('/api/search/electricheatpump', {params:{filter}})
    },
    load({commit}, dataString) {
        commit('load', dataString)
    }
}

const mutations = {
    /**
     * 検索結果をstateに保存
     */
    setResult(state, {value, result, type}){
        state.result = result
        state.type = type
        state.value = value
    },
    /**
     * 選択された機器をstateに保存
     */
    setSelected(state, {value, type}){
        const selected_data = state.result.filter(x => {
            return x.value == value
        })
        state.selected[type] = selected_data[0]
    },
    load(state, dataString) {
        if (dataString.cogen_type == 1) {
            state.selected.pefc = {
                backupBoilerNumber:dataString.cogen_backupboiler_number,
                brandCompanyName:dataString.cogen_brand_company_name,
                certificationNumber:dataString.cogen_certification_number,
                powerUnitNumber:dataString.cogen_powerunit_number,
                tankUnitNumber:dataString.cogen_tankunit_number,
                type:"PEFC",
                value:dataString.cogen_pefc_package_id,
            }
        } else if (dataString.cogen_type == 2) {
            state.selected.sofc = {
                backupBoilerNumber:dataString.cogen_backupboiler_number,
                brandCompanyName:dataString.cogen_brand_company_name,
                certificationNumber:dataString.cogen_certification_number,
                powerUnitNumber:dataString.cogen_powerunit_number,
                tankUnitNumber:dataString.cogen_tankunit_number,
                type:"SOFC",
                value:dataString.cogen_sofc_package_id,
            }
        }
        if (dataString.hw_senyo_sr6_spec_method == 4) {
            state.selected.electricHeatPump = {
                brandCompanyName:dataString.hw_senyo_sr6_brand_company_name,
                certificationNumber:dataString.hw_senyo_sr6_certification_number,
                powerUnitNumber:dataString.hw_senyo_sr6_heat_pump_unit_number,
                systemNumber:dataString.hw_senyo_sr6_system_number,
                tankUnitNumber:dataString.hw_senyo_sr6_tank_unit_number,
                value:dataString.hw_senyo_sr6_package_id,
            }
        }
        if (dataString.hw_senyo_sr7_package_input == 1) {
            state.selected.hw_senyo = {
                backupBoilerNumber:dataString.hw_senyo_sr7_backup_boiler_number,
                brandCompanyName:dataString.hw_senyo_sr7_brand_company_name,
                certificationNumber:dataString.hw_senyo_sr7_certification_number,
                tankUnitNumber:dataString.hw_senyo_sr7_tank_unit_number,
                value:dataString.hw_senyo_sr7_package_id,
            }
        }
        if (dataString.hw_ittai_sr18_package_input == 1) {
            state.selected.hw_ittai = {
                backupBoilerNumber:dataString.hw_ittai_sr18_backup_boiler_number,
                brandCompanyName:dataString.hw_ittai_sr18_brand_company_name,
                certificationNumber:dataString.hw_ittai_sr18_certification_number,
                tankUnitNumber:dataString.hw_ittai_sr18_tank_unit_number,
                value:dataString.hw_ittai_sr18_package_id,
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}